import React from "react";
import Container from "react-bootstrap/Container";
import { Redirect } from "react-router-dom";

import {
  CheckoutDetails,
  CheckoutForm,
  CheckoutHeader,
  TopBar,
  Loading,
  Whatsapp,
} from "../components";

import { useCheckout } from "../hooks/useCheckout";
import { useDiscountValidation } from "../hooks/useDiscountValidation";
import { buildDiscountedCheckout } from "../components/utils/buildDiscountedCheckout";
import { CheckoutLockedUtil } from "../components/CheckoutLocked/utils/CheckoutLockedUtil";
import { CheckoutFooter } from "../components/CheckoutFooter/CheckoutFooter";

function PageDetails() {
  const { getCheckout, loading, checkout, organization, countries, error } =
    useCheckout();
  const { discount, validateDiscount, resetDiscount } = useDiscountValidation(
    checkout?.id,
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => await getCheckout(), []);

  if (loading || !checkout) {
    return <Loading />;
  }

  if (error) {
    return <Redirect to="/" />;
  }

  if (!CheckoutLockedUtil.userCanPurchase(checkout)) {
    return <Redirect to={CheckoutLockedUtil.checkoutLockedURL(checkout)} />;
  }

  const displayCheckout = discount?.valid
    ? buildDiscountedCheckout(checkout, discount)
    : checkout;

  return (
    <div>
      <Whatsapp url={checkout?.whatsapp_support_line} />
      <TopBar />

      <Container className="text-center">
        <CheckoutHeader checkout={checkout} organization={organization} />
        <CheckoutDetails checkout={displayCheckout} discount={discount} />
        <CheckoutForm
          checkout={displayCheckout}
          countries={countries}
          discountEnabled={checkout?.discount_enabled}
          discount={discount}
          onValidateDiscountEmail={validateDiscount}
          onResetDiscount={resetDiscount}
        />
        <CheckoutFooter checkout={checkout} organization={organization || {}} />
      </Container>
    </div>
  );
}

export default PageDetails;
